import {
  getAuthList,
  upLoadImage,
  getKey,
  getAllVillageList,
  getUploadToken,
  getStorePayStatusInfo
} from '@/api/base.js'

const state = {
  auth_list: [],
  page_index: '0',
  upload_token: '',
  store_info: ''
}

const mutations = {
  SET_PAGE_INDEX: (state, page_index) => {
    state.page_index = page_index
  },
  SET_AUTH_LIST: (state, auth_list) => {
    state.auth_list = auth_list
  },
  SET_UPLOAD_TOKEN: (state, upload_token) => {
    state.upload_token = upload_token
  },
  SET_STORE_INFO: (state, store_info) => {
    state.store_info = store_info
  }
}

const actions = {
  setPageType({ commit }, data) {
    commit('SET_PAGE_INDEX', data)
  },
  // 获取权限列表
  getAuthList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getAuthList(data).then(response => {
        // commit('SET_WX_FLOCK_ID', response.data.data.auth_list)
        resolve(response.data.data.auth_list)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getKey({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getKey(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAllVillageList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getAllVillageList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getUploadToken({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      if (state.upload_token) {
        resolve(state.upload_token)
        return
      }
      getUploadToken(data).then(response => {
        const uploadToken = response.data.data.uploadToken
        commit('SET_UPLOAD_TOKEN', uploadToken)
        resolve(uploadToken)
      }).catch(error => {
        reject(error)
      })
    })
  },
  async upLoadImage({ state, commit, dispatch }, data) {
    try {
      const image_type_key = data.params.jsonText ? JSON.parse(data.params.jsonText).image_type_key : data.params.image_type_key
      const file = data.file
      const uploadToken = await dispatch('getUploadToken')
      const nameArr = file.name.split('.')
      const suffix = nameArr.pop()
      const name = nameArr.join('.') + '-' + (parseInt((new Date().getTime() / 1000)) + '_' + parseInt(Math.random() * 1000))
      const res = await upLoadImage(data.file, {
        token: uploadToken,
        key: [image_type_key, name].filter(Boolean).join('_') + '.' + suffix
      })
      return {
        file_info: {
          name: res.data.key,
          url: process.env.VUE_APP_QINIU_URL + '/' + res.data.key
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        commit('SET_UPLOAD_TOKEN', '')
        return await dispatch('upLoadImage', data)
      }
      throw error
    }
  },
  getStorePayStatusInfo({ state, commit }, data) {
    if (state.store_info) return state.store_info
    return new Promise((resolve, reject) => {
      getStorePayStatusInfo(data).then(response => {
        commit('SET_STORE_INFO', response.data.data.store_info)
        const data = response.data.data.store_info
        resolve(data)
        console.log(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
